// ===========================================================================
// Membership Analytics (Module J) — fake data determinístico.
//
// Backend futuro (según docs/modulos/BillingV2/MODULO_J_MEMBERSHIP_ANALYTICS.md):
//   GET /api/membership/snapshot?months=12     → mdm.TAB_MEMBERSHIP_SNAPSHOT
//   GET /api/membership/churn-flags            → mdm.TAB_CHURN_FLAGS
//   GET /api/membership/plan-mix               → roster (patinfo.TAB_MEMBERSHIPS)
//
// Todo lo que aquí es fake (tendencia mensual, churn por centro, PMPM) será
// reemplazado por esos endpoints. Los valores son deterministas (sin Math.random)
// para que la UI sea estable entre renders y demos.
// ===========================================================================

/**
 * Snapshot mensual del roster (últimos 12 meses).
 * members[i] = members[i-1] + adds - drops (serie consistente).
 * Anclada al total real del overview poblacional (~10,462 a 2026-05).
 * Futuro: GET /api/membership/snapshot?months=12
 */
export const FAKE_MEMBERSHIP_TREND = [
  { month: "2025-06", members: 10818, adds: 92, drops: 134 },
  { month: "2025-07", members: 10761, adds: 81, drops: 138 },
  { month: "2025-08", members: 10742, adds: 96, drops: 115 },
  { month: "2025-09", members: 10695, adds: 74, drops: 121 },
  { month: "2025-10", members: 10650, adds: 88, drops: 133 },
  { month: "2025-11", members: 10684, adds: 147, drops: 113 },
  { month: "2025-12", members: 10691, adds: 121, drops: 114 },
  { month: "2026-01", members: 11074, adds: 562, drops: 179 }, // Open Enrollment
  { month: "2026-02", members: 10942, adds: 73, drops: 205 },
  { month: "2026-03", members: 10803, adds: 69, drops: 208 },
  { month: "2026-04", members: 10655, adds: 81, drops: 229 },
  { month: "2026-05", members: 10462, adds: 64, drops: 257 },
];

/**
 * Revenue promedio por miembro por mes (premium PMPM).
 * Futuro: viene del parser LAB8R via finance schema (Módulo K).
 */
export const FAKE_AVG_REVENUE_PMPM = 301;

/**
 * Plan mix fallback si el roster real (new_members.json) no está disponible.
 * Futuro: GET /api/membership/plan-mix
 */
export const FAKE_PLAN_MIX = [
  { plan: "myBlue Bronze 2129", members: 312, pct: 33.8 },
  { plan: "myBlue Bronze 1601", members: 256, pct: 27.7 },
  { plan: "myBlue Silver 2130", members: 148, pct: 16.0 },
  { plan: "myBlue Bronze 2416", members: 102, pct: 11.1 },
  { plan: "myBlue Silver 1605", members: 64, pct: 6.9 },
  { plan: "myBlue Gold 1607", members: 41, pct: 4.5 },
];

/** Hash determinístico simple para derivar métricas estables por centro. */
export const hashString = (s = "") => {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
};

/**
 * Perfil de churn/crecimiento determinístico por centro.
 * Futuro: GET /api/membership/churn-flags (mdm.TAB_CHURN_FLAGS por location).
 *
 * @param {string} centerName - nombre del centro (e.g. "Fort Myers")
 * @param {number} totalPatients - panel actual del centro
 */
export const getCenterChurnProfile = (centerName, totalPatients = 0) => {
  const h = hashString(centerName);
  const churnRate = 1.2 + (h % 19) / 10; // 1.2% – 3.0%
  const netMoM = Math.round((totalPatients * ((h % 25) - 16)) / 1000); // ~ -1.6%..+0.8%
  const avgPmpm = 268 + (h % 70); // $268 – $337
  return { churnRate, netMoM, avgPmpm };
};
